import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LoadingService {

  get loading() {
    return this._loading;
  }

  set loading(value) {
    this._loading = value;
    this.loadingStatus.next(value);
  }
  loadingStatus: Subject<boolean> = new Subject();
  private _loading = false;

  endLoading() {
    this.loading = false;
  }

  startLoading() {
    this.loading = true;
  }
}
